import { ReactNode } from "react";

const PATHS: Record<string, ReactNode> = {
  home: (<><path d="M3 11l9-8 9 8" /><path d="M5 10v10h14V10" /></>),
  grid: (<><rect x="3" y="3" width="7" height="7" rx="1.5" /><rect x="14" y="3" width="7" height="7" rx="1.5" /><rect x="3" y="14" width="7" height="7" rx="1.5" /><rect x="14" y="14" width="7" height="7" rx="1.5" /></>),
  pipe: (<path d="M3 12h4l3-7 4 14 3-7h4" />),
  ops: (<><circle cx="12" cy="12" r="3" /><path d="M19 12a7 7 0 0 0-.4-2.3l1.7-1.3-2-3.4-2 .8a7 7 0 0 0-4-2.3L12 1H8.7l-.4 2.5a7 7 0 0 0-4 2.3l-2-.8-2 3.4 1.7 1.3A7 7 0 0 0 1.7 12c0 .8.1 1.6.4 2.3l-1.7 1.3 2 3.4 2-.8a7 7 0 0 0 4 2.3l.4 2.5h3.3l.4-2.5a7 7 0 0 0 4-2.3l2 .8 2-3.4-1.7-1.3c.3-.7.4-1.5.4-2.3z" /></>),
  book: (<><path d="M4 4h11a3 3 0 0 1 3 3v13H7a3 3 0 0 1-3-3z" /><path d="M4 17a3 3 0 0 1 3-3h11" /></>),
  bolt: (<path d="M13 2L4 14h7l-1 8 9-12h-7z" />),
  play: (<path d="M6 4l14 8-14 8z" />),
  bell: (<><path d="M6 8a6 6 0 1 1 12 0c0 7 3 8 3 8H3s3-1 3-8" /><path d="M10 21a2 2 0 0 0 4 0" /></>),
  mail: (<><rect x="3" y="5" width="18" height="14" rx="2" /><path d="M3 7l9 7 9-7" /></>),
  cal: (<><rect x="3" y="5" width="18" height="16" rx="2" /><path d="M3 9h18M8 3v4M16 3v4" /></>),
  check: (<path d="M5 12l5 5L20 7" />),
  plus: (<path d="M12 5v14M5 12h14" />),
  arrow: (<path d="M5 12h14M13 6l6 6-6 6" />),
  search: (<><circle cx="11" cy="11" r="7" /><path d="M21 21l-4.3-4.3" /></>),
  user: (<><circle cx="12" cy="8" r="4" /><path d="M4 21a8 8 0 0 1 16 0" /></>),
};

export type IconName = keyof typeof PATHS | string;

export default function AtriumIcon({ name, size = 14 }: { name: IconName; size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.6}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      {PATHS[name] ?? null}
    </svg>
  );
}
